import StringUtils from './StringUtils';

namespace TournamentsUtils {
  const cdnUrl = process.env.NEXT_PUBLIC_CDN_URL || 'https://cdn.bloomapp.com';

  export const TOURNAMENT_STATUS_BADGE = {
    InProgress: 'Live',
    Open: 'Upcoming',
    Finished: 'Ended',
    Inactive: 'Inactive',
    Cancelled: 'Cancelled',
  };

  export const TOURNAMENT_STATUS_ICON_COLOR = {
    Open: 'text-success',
    InProgress: 'text-pink',
    Finished: 'text-secondary',
    Inactive: 'text-secondary',
    Cancelled: 'text-secondary',
  };

  export const TOURNAMENT_STATUS = {
    Open: {
      color: 'text-success',
      status: {
        title: 'Get {budget} to invest',
        subtitle: 'Join the tournament to unlock {budget} in virtual cash and start picking stocks & ETFs.',
      },
    },
    Open_Participating: {
      color: 'text-success',
      status: {
        title: 'You have {budget} ready to invest',
        subtitle: 'Pick your stocks & ETFs before the tournament starts!',
      },
    },
    InProgress: {
      color: 'text-pink',
      status: {
        title: 'This tournament is already live.',
        subtitle: 'Join the next one below.',
      },
    },
    Finished: {
      color: 'text-secondary',
      status: {
        title: 'This tournament has already ended',
        subtitle: 'Join the next one instead!',
      },
    },
    Inactive: {
      color: 'text-secondary',
      status: {
        title: '',
        subtitle: '',
      },
    },

    Cancelled: {
      color: 'text-secondary',
      status: {
        title: 'This tournament was cancelled.',
        subtitle: 'There weren\'t enough participants to start this tournament.',
      },
    },
    format: (text: string, replace: {}) => StringUtils.format(text, replace),
  };

  export function getDynamicImageUrl(prefix: string, imageKey: string, extension: string): string {
    return `${cdnUrl}/${prefix}/${imageKey}.${extension}`;
  }

  export function getTournamentType(name: string) {
    if (name?.toLowerCase().match(/daily/g)) return 'daily';
    if (name?.toLowerCase().match(/weekly/g)) return 'weekly';
    return 'monthly';
  }

  export function getInstitutionId(stringData: string): string | undefined {
    const id = stringData.split(" - ")[1]
    return id
  }

  export function getName(stringData: string) {
    const matchChar = ' - ';
    if (stringData.includes(matchChar)) return stringData.split(matchChar)[0]
    return stringData
  }
}

export default TournamentsUtils;
